var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 77.5C60.7107 77.5 77.5 60.7107 77.5 40C77.5 19.2893 60.7107 2.5 40 2.5C19.2893 2.5 2.5 19.2893 2.5 40C2.5 60.7107 19.2893 77.5 40 77.5Z",
    fill: "#2EBB49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0002 2.5C60.7108 2.5 77.5002 19.2894 77.5002 40C77.5002 60.7106 60.7108 77.5 40.0002 77.5C39.2127 77.5 38.4317 77.4728 37.6562 77.425C57.2747 76.2147 72.8125 59.9233 72.8125 40C72.8125 20.0767 57.2747 3.78531 37.6562 2.575C38.4316 2.52719 39.2127 2.5 40.0002 2.5Z",
    fill: "#13972C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4467 42.2267C20.8632 40.7697 20.7609 38.3048 22.2179 36.7214C23.6749 35.1379 26.1398 35.0356 27.7232 36.4926L35.7113 43.8286L52.2152 28.027C53.7649 26.5362 56.2298 26.584 57.7204 28.1337C59.2112 29.6834 59.1634 32.1483 57.6137 33.639L38.5609 51.8809C37.0959 53.392 34.6846 53.4683 33.1266 52.0347L22.4467 42.2267Z",
    fill: "#F4F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck3D);
export default __webpack_public_path__ + "static/media/check-3d.a815bbdaa5e0caaf11472ae37098a512.svg";
export { ForwardRef as ReactComponent };